import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useForm } from '@inertiajs/vue3';
    import { CreditCard } from '@/types';
    import DialogForm from '@/components/DialogForm.vue';
    import CreditCardForm from '@/components/credit-cards/CreditCardForm.vue';
    import { useI18n } from 'vue-i18n';
    import { usePage } from '@inertiajs/vue3';
    import { computed } from 'vue';
    import type { SharedData } from '@/types';
    import QueryKey from '@/enums/QueryKey';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EditCreditCard',
  props: {
    creditCard: {}
  },
  setup(__props: any) {

    const { t } = useI18n();
    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const props = __props;

    const form = useForm({
        id: props.creditCard.id,
        name: props.creditCard.name,
        number: props.creditCard.number,
        type: props.creditCard.type,
        employee_ids: props.creditCard.assigned_ids,
        user_ids: props.creditCard.assigned_user_ids ?? [],
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogForm, {
    type: "update",
    form: _unref(form),
    route: 
            _ctx.route('v2.credit-cards.update', {
                company: selectedCompanyId.value,
                creditCard: _ctx.creditCard.id,
            })
        ,
    "query-key": [_unref(QueryKey).CREDIT_CARDS, selectedCompanyId.value],
    title: "credit-cards.edit.title",
    "success-message-translated": _unref(t)('credit-cards.edit.success', { name: _unref(form).name })
  }, {
    default: _withCtx(() => [
      _createVNode(CreditCardForm, { form: _unref(form) }, null, 8, ["form"])
    ]),
    _: 1
  }, 8, ["form", "route", "query-key", "success-message-translated"]))
}
}

})